<template>
<el-container>
    <el-header class="header">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }" style="font-size: 16px;">Home</el-breadcrumb-item>
        <el-breadcrumb-item style="font-size: 16px;">Search</el-breadcrumb-item>
        <el-breadcrumb-item style="font-size: 16px;">Network of TFs-Enhancer-Genes</el-breadcrumb-item>
    </el-breadcrumb>
    </el-header>
    <el-aside width="3px"></el-aside>
    <el-main>
    <el-container>
        <el-aside class="aside">
        <div>
            <Shipselect @search="handleSearch" />
        </div>
        </el-aside>
        <el-main>
        <div v-if="selectedSpecies !== '' && selectedTissue !== ''">
             <!-- 在选择了物种和组织类型后显示 Shippanel 组件 -->
            <Shippanel :species="selectedSpecies" :tissue="selectedTissue" :key="selectedSpecies + selectedTissue" />
        </div>
        </el-main>
    </el-container>
    </el-main>
    <el-aside width="3px"></el-aside>
</el-container>
</template>

<script>
import Shipselect from '../relationship1/Shipselect.vue';
import Shippanel from '../relationship1/Shippanel.vue';

export default {
    components: {
        Shipselect,
        Shippanel
    },
    data() {
        return {
            selectedSpecies: '',
            selectedTissue: ''
        };
    },
    created() {
        // 在组件创建时，设置默认参数值
        this.selectedSpecies = 'human';
        this.selectedTissue = 'DE';
    },
    methods: {
        handleSearch(params) {
            this.selectedSpecies = params.Species;
            this.selectedTissue = params.Tissue;
        }
    }
};
</script>

<style scoped>
.header {
    padding: 0px;
    border-bottom: 1px solid #ccc;
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin-top: 60px;
}
.aside {
    width: 240px;
    border-right: 1px dashed #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/search/Relationship1.vue